/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendlyAuthorization } from '../../models/calendly-authorization';

export interface StartCalendlyOAuth$Params {
}

export function startCalendlyOAuth(http: HttpClient, rootUrl: string, params?: StartCalendlyOAuth$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendlyAuthorization>> {
  const rb = new RequestBuilder(rootUrl, startCalendlyOAuth.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendlyAuthorization>;
    })
  );
}

startCalendlyOAuth.PATH = '/v1/api/ui/calendly-demo/oauth/connect';
